export const iconConfig = {
  'pysb': 'shenbao', //评优申报
  'xmsb': 'xiangmujijushenqing', //项目申报
  'psdf': 'pingshenqueren', //评审管理
  'knsq': 'kunnanrenyuanshenqing', //困难帮扶
  'xwzx': 'xinwen1', //新闻中心
  'hdbm': 'menu_hdbm', //活动报名
  'zxxx': 'xuexi3', //在线学习
  //'yjzj': 'yijianfankui', //调研征集
  //'gjzj': 'wodewengao', //稿件征集
  //'xwtg': 'tougao', //新闻投稿
  //'ldyjx': 'yijianxiang', //领导意见箱
  // 'zycsxy': 'xuanchuance', //职业操守宣言
  //'wdgrxx': 'gerenxinxi', //我的个人信息
  //'zzmb': 'mubiao', //组织目标
  //'dylxyg': 'lianxiren', //党员联系员工
  'xlxx': 'xinling1', //心灵信箱
  'xsjy': 'yijianxiang', //心声建议
  // 'ljzm': 'wodewengao', //心灵信箱
  //'zdsy': 'guizhangzhidu1', //制度索引
  //'rdsq': 'dangjian', //入党申请
  //'rtsq': 'rutuan', //入团申请 
  //'rhsq': '-gonghui' //入会申请
  'dcwj': 'xiangmujiexiang',
  // 'zjyj': 'yijian1' //征集意见
}

export const titleConfig = {
  'pysb': '评优申报', //评优申报
  'hdbm': '最新活动', //活动报名
  'xmsb': '项目申报', //项目申报
  'knsq': '困难帮扶', //困难帮扶
  'zxxx': '在线学习', //在线学习
  'xsjy': '心声建议', //心声建议
  //'ldyjx': '意见箱', //意见箱
  //'yjzj': '调研征集', //调研征集
  //'gjzj': '稿件征集', //稿件征集
  //'xwtg': '新闻投稿', //新闻投稿
  // 'zycsxy': '职业操守宣言', //职业操守宣言
  //'wdgrxx': '我的个人信息', //我的个人信息
  //'zzmb': '组织目标', //组织目标
  //'dylxyg': '党员联系员工', //党员联系员工
  'xlxx': '心灵信箱', //心灵信箱
  // 'ljzm': '廉洁证明', //心灵信箱
  'xwzx': 'BOE家事', //新闻中心
  //'zdsy': '制度索引', //制度索引
  //'rdsq': '入党申请', //入党申请
  //'rtsq': '入团申请', //入团申请 
  //'rhsq': '入会申请', //入会申请
  'psdf': '评审管理', //评审管理
  'dcwj': '调查问卷',
  // 'zjyj': '征集意见'
}